module.exports = __webpack_public_path__ + "static/img/SAAS标准版背景@2x1.269c6177.png";